<template>
  <button
    :class="buttonClasses"
    @click="handleClick"
    :disabled="props.isDisabled || props.isLoading">
    <div v-if="props.isLoading" class="tw-relative tw-animate-spin tw-ease tw-duration-300">
      <span class="fa fa-spinner"></span>
    </div>
    <span v-else v-bind:class="[props.isLoading ? 'tw-absolute tw-invisible' : 'tw-static']">
      <span :class="props.iconClass" v-if="props.iconClass"></span>{{props.buttonText}}
    </span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  buttonText: String,
  cssClass: String,
  iconClass: String,
  isLoading: Boolean,
  isDisabled: Boolean
})

const emit = defineEmits(['emitClick'])

const handleClick = (event: Event) => {
  emit('emitClick', event)
}

const buttonClasses = computed(() => {
  if (props.isDisabled || props.isLoading) {
    return props.cssClass + ' tw-relative tw-opacity-30 tw-cursor-not-allowed';
  }

  return props.cssClass + ' tw-relative';
})
</script>